export default "__VITE_ASSET__ChugACfb__"